module.exports = __webpack_public_path__ + "img/candle-quartz-2.d28af712.jpg";